import {
  getPlanDefault
} from '@/api/plan.api'

const state = {
  planDefault: {
    plan: {},
    installments: []
  }
}

const mutations = {
  setPlanDefault (state, plan) {
    state.planDefault = plan
  }
}

const getters = {
  planDefault ({ planDefault }) {
    return planDefault
  },
}

const actions = {
  async fetchPlanDefault ({ commit }) {
    const plan = await getPlanDefault()
    commit('setPlanDefault', plan)
    return plan
  }
}


export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
